import React from 'react'

import './styles.scss'

import { IntroProps } from '../types'

import backgroundDesktop from './img/background-desktop.jpg'
import overlayDesktop from './img/overlay-desktop.png'
import backgroundMobile from './img/background-mobile.jpg'
import overlayMobile from './img/overlay-mobile.png'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSimplifiedName, weddingDate },
  buttonMessage,
  warningMessage,
  background,
  locale = 'pt-BR',
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const date = new Intl.DateTimeFormat(locale).format(
    new Date(weddingDate.timestamp)
  )

  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro331">
      <div className="animated-intro-small screen">
        <img
          className="background-4QFuFN bp1-animate-enter"
          src={background || backgroundMobile}
        />
        <img className="overlay-4QFuFN" src={overlayMobile} />
        <div
          className="site-de-casamento-e-4QFuFN"
          dangerouslySetInnerHTML={{ __html: warningMessage }}
        />
        <button className="button-4QFuFN" onClick={onSkipIntro}>
          <div className="pular-introduo-YrZHDo">{buttonMessage}</div>
        </button>
        <div className="couple-name-date-4QFuFN notranslate">
          <div className="m-e-WvVO7F bp1-animate-enter1">
            {coupleSimplifiedName.bride}
            {coupleSimplifiedName.groom && ` & ${coupleSimplifiedName.groom}`}
          </div>
          <div className="x08062024-WvVO7F bp1-animate-enter2">{date}</div>
        </div>
      </div>

      <div className="full-project screen">
        <img
          className="background-KqxCzi bp2-animate-enter"
          src={background || backgroundDesktop}
        />
        <img className="overlay-KqxCzi" src={overlayDesktop} />
        <div className="button-KqxCzi">
          <div
            className="site-de-casamento-e-FRZ0F7"
            dangerouslySetInnerHTML={{ __html: warningMessage }}
          />
          <button className="button-FRZ0F7" onClick={onSkipIntro}>
            <div className="pular-introduo-kvlGz8">{buttonMessage}</div>
          </button>
        </div>
        <div className="couple-name-and-date-KqxCzi notranslate">
          <div className="m-e-CHGsYT bp2-animate-enter1">
            {coupleSimplifiedName.bride}
            {coupleSimplifiedName.groom && ` & ${coupleSimplifiedName.groom}`}
          </div>
          <div className="x08062024-CHGsYT bp2-animate-enter2">{date}</div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
